import { query, mutate } from '../api/client';
import { gql } from 'apollo-boost';
import {
    COUNTRIES_QUERY,
    TAGS_QUERY,
    LITTER_REPORT_QUERY,
    LITTER_REPORT_COUNT_QUERY,
    FORM_DETAILS_MUTATION,
    REPORT_SCHEDULER_MUTATION,
} from './constants';
import { logException } from '../logger';

export async function fetchCountries() {
    const countries = await query({
        query: gql`
            ${COUNTRIES_QUERY}
        `,
    });

    return countries.data.countries;
}

export async function fetchTags() {
    const tags = await query({
        query: gql`
            ${TAGS_QUERY}
        `,
    });

    return tags.data.tags;
}

export async function fetchLitterReport(filters = {}) {
    try {
        const report = await query({
            variables: filters,
            query: gql`
                ${LITTER_REPORT_QUERY}
            `,
        });

        return report.data.litters_report;
    } catch (e) {
        // console.log({
        //     e,
        // });
        logException(e);
    }
}

export async function fetchLittersForMap(filters = {}) {
    const params = { ...filters, limit: 50000 };
    try {
        const report = await query({
            variables: params,
            query: gql`
                ${LITTER_REPORT_QUERY}
            `,
        });

        return report.data.litters_report;
    } catch (e) {
        // console.log({
        //     e,
        // });
        logException(e);
    }
}

export async function fetchLitterReportCount(filters = {}) {
    try {
        const report = await query({
            variables: filters,
            query: gql`
                ${LITTER_REPORT_COUNT_QUERY}
            `,
        });

        return report.data.litter_report_count;
    } catch (e) {
        // console.log({
        //     e,
        // });
        logException(e);
    }
}

export async function sendRequestForm({
    name,
    email,
    phone,
    organization,
    purpose,
    reference,
    extraInfo,
    expandedData,
}) {
    try {
        const result = await mutate({
            variables: {
                name,
                email,
                phone,
                organization,
                purpose,
                reference,
                extraInfo,
                expandedData,
            },
            mutation: gql`
                ${FORM_DETAILS_MUTATION}
            `,
        });

        return result.data.submit_form_data;
    } catch (e) {
        logException(e);
        return false;
    }
}

export async function sendLitterReport(reportDetails = {}) {
    try {
        const report = await mutate({
            variables: reportDetails,
            mutation: gql`
                ${REPORT_SCHEDULER_MUTATION}
            `,
        });

        return report.data.save_report_scheduler;
    } catch (e) {
        logException(e);
        // console.log({
            //     e,
            // });// console.log({
        //     e,
        // });
    }
}
